import { useUser } from "@procurement-agents/auth";
import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { modulesFor } from "./modules";

/** The grid button in the header: switch between modules from anywhere, without going back to the workspace home. */
export function ModuleMenu() {
  const user = useUser();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const loc = useLocation();
  const modules = modulesFor(user);
  useEffect(() => { setOpen(false); }, [loc.pathname]);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onDown); window.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("mousedown", onDown); window.removeEventListener("keydown", onKey); };
  }, [open]);
  if (!modules.length) return null;
  const current = modules.find((m) => loc.pathname === m.to || loc.pathname.startsWith(m.to + "/"));
  return (
    <div className="module-menu" ref={ref}>
      <button type="button" className="grid-btn" aria-label="Switch module" aria-haspopup="menu" aria-expanded={open} title="Switch module" onClick={() => setOpen((o) => !o)}>
        <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden><rect x="1" y="1" width="6" height="6" rx="1.2" /><rect x="11" y="1" width="6" height="6" rx="1.2" /><rect x="1" y="11" width="6" height="6" rx="1.2" /><rect x="11" y="11" width="6" height="6" rx="1.2" /></svg>
      </button>
      {open && (
        <ul className="module-list" role="menu" aria-label="Modules">
          <li role="none"><Link role="menuitem" to="/" className={loc.pathname === "/" ? "current" : ""}><strong>Workspace</strong><span className="muted small">All modules and what needs you</span></Link></li>
          {modules.map((m) => (
            <li key={m.id} role="none"><Link role="menuitem" to={m.to} className={current?.id === m.id ? "current" : ""} aria-current={current?.id === m.id ? "page" : undefined}><strong>{m.name}</strong><span className="muted small">{m.blurb}</span></Link></li>
          ))}
        </ul>
      )}
    </div>
  );
}
